/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ref_TitleInputs */

const en_to_typescript_ref_title = /** @type {(inputs: To_Typescript_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How JSON values map to TypeScript types`)
};

const ko_to_typescript_ref_title = /** @type {(inputs: To_Typescript_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 값이 TypeScript 타입으로 대응되는 방식`)
};

const ja_to_typescript_ref_title = /** @type {(inputs: To_Typescript_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON の値が TypeScript の型に対応する仕組み`)
};

/**
* | output |
* | --- |
* | "How JSON values map to TypeScript types" |
*
* @param {To_Typescript_Ref_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ref_title = /** @type {((inputs?: To_Typescript_Ref_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ref_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ref_title(inputs)
	if (locale === "ko") return ko_to_typescript_ref_title(inputs)
	return ja_to_typescript_ref_title(inputs)
});